import type { Traducao, Idioma } from '../textos.ts'

export const TEXTOS_DO_CALENDARIO = {
  anterior: { 'pt-BR': 'Mês anterior', 'es-419': 'Mes anterior', 'en-US': 'Previous month' },
  proximo: { 'pt-BR': 'Próximo mês', 'es-419': 'Mes siguiente', 'en-US': 'Next month' },
  hoje: { 'pt-BR': 'Hoje', 'es-419': 'Hoy', 'en-US': 'Today' },
  limpar: { 'pt-BR': 'Limpar', 'es-419': 'Limpiar', 'en-US': 'Clear' },
} satisfies Readonly<Record<string, Traducao>>

export const MESES_DO_CALENDARIO: Readonly<Record<Idioma, readonly string[]>> = {
  'pt-BR': ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  'es-419': ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  'en-US': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
}

/** A semana continua começando no domingo; só os rótulos seguem o idioma. */
export const DIAS_DO_CALENDARIO: Readonly<Record<Idioma, readonly string[]>> = {
  'pt-BR': ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  'es-419': ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  'en-US': ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
}
